import React from 'react'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import {
  CONTROL_STATUS,
  Control,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import {
  useCanPerformAction,
  useHasRequiredPermissions,
} from 'src/app/AppAuth/AppAuth.hooks'
import { PERMISSIONS } from 'src/config/roleConfig'
import { BasicDropdownMenu } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { DropdownToggleButton } from '../../../../components/Reusable/Buttons'
import { ReactComponent as VerticalEllipsesIcon } from '../../../../components/Icons/assets/vertical-ellipses-icon.svg'
import { useCurrentControl } from '../../../../context/FormContext'
import { TestIds } from '../../../../Utils/testIds'
import {
  ViewDetails,
  RemoveControl,
  CopyLink,
  InScopeItems,
  DeleteControl,
  ViewActivities,
} from './ControlsListItemMenuComponents'

export const ControlsListItemMenu = ({
  control,
}: {
  control: Control.AsObject
}): JSX.Element => {
  const canDeleteControls = useCanPerformAction<Control.AsObject>(
    CAPABILITY.CAN_DELETE_CONTROLS,
    control,
  )
  const canViewActivities = useCanPerformAction(
    CAPABILITY.CAN_VIEW_ACTIVITY_LOG,
  )
  const hasRequestPagePermissions = useHasRequiredPermissions([
    PERMISSIONS.READ,
    PERMISSIONS.AUDITOR_ACTION,
  ])
  const { setCurrentControl } = useCurrentControl()
  const { requestId } = useParams()

  const setCurrentControlHandler = () => {
    setCurrentControl(control)
  }

  const isNotApplicable = control.status === CONTROL_STATUS.NOTAPPLICABLE

  if (!hasRequestPagePermissions && requestId) {
    return <></>
  }

  return (
    <Dropdown id={`controls-index-menu-${control.id}`}>
      <Dropdown.Toggle
        as={DropdownToggleButton}
        onClickFunc={setCurrentControlHandler}
        data-testid={TestIds.CONTROL_LIST_ITEM_MENU_TOGGLE}
      >
        <VerticalEllipsesIcon />
      </Dropdown.Toggle>
      <BasicDropdownMenu>
        {requestId ? (
          <>
            <ViewDetails />
            <RemoveControl {...{ requestId, control }} />
            <CopyLink />
          </>
        ) : (
          <>
            <ViewDetails />
            <Dropdown.Divider />
            {!isNotApplicable && <InScopeItems control={control} />}
            {canDeleteControls && (
              <>
                <DeleteControl />
                <Dropdown.Divider />
              </>
            )}
            <CopyLink />
            {canViewActivities && <ViewActivities />}
          </>
        )}
      </BasicDropdownMenu>
    </Dropdown>
  )
}
